import { IAgoraRTCClient, IAgoraRTCRemoteUser, ICameraVideoTrack, IMicrophoneAudioTrack, UID } from 'agora-rtc-sdk-ng';
import React from 'react';
import { HttpHandler } from '../../api/HttpHandler';
import { environment } from '../../enviroments';
import { ConsultationType } from '../types';

export enum VideoStatus {
  'mute-video' = 'mute-video',
  'unmute-video' = 'unmute-video',
  'enable-local-video' = 'enable-local-video',
  'disable-local-video' = 'disable-local-video',
}

export enum AudioStatus {
  'mute-audio' = 'mute-audio',
  'unmute-audio' = 'unmute-audio',
}

export const errorToMessage = (errorCode: string) => {
  switch (errorCode) {
    case 'PERMISSION_DENIED':
      return 'Для коректної роботи відеочату, потрібно надати доступ до камери та мікрофону.';
    case 'ACCESS_DENIED':
      return 'Доступ до цієї консультації закритий.';
    default:
      return 'Упс, щось пішло не так. Спробуйте ще раз, або зв`яжіться з тех.підтримкою.';
  }
};
export const userInfoUpdatedEventHandler = (
  setVideoStatus: React.Dispatch<React.SetStateAction<VideoStatus | null>>,
  setAudioStatus: React.Dispatch<React.SetStateAction<AudioStatus | null>>
) => {
  return (
    uid: UID,
    msg: 'mute-audio' | 'mute-video' | 'enable-local-video' | 'unmute-audio' | 'unmute-video' | 'disable-local-video'
  ) => {
    if (uid.toString().includes('_screen')) return;

    if (Object.keys(AudioStatus).includes(msg)) setAudioStatus(msg as AudioStatus);

    if (Object.keys(VideoStatus).includes(msg)) setVideoStatus(msg as VideoStatus);
  };
};

export const userPublishedEventHandler = (
  client: IAgoraRTCClient,
  videoContainer: React.MutableRefObject<HTMLDivElement | null>,
  setUsers: React.Dispatch<React.SetStateAction<IAgoraRTCRemoteUser[]>>
) => {
  return async (user: IAgoraRTCRemoteUser, mediaType: 'video' | 'audio') => {
    await client.subscribe(user, mediaType);
    setUsers(Array.from(client.remoteUsers));

    client.remoteUsers.forEach((remoteUser) => remoteUser.audioTrack?.play());
  };
};

export const userJoinedOrLeftEventHandler = (
  setUsers: React.Dispatch<React.SetStateAction<IAgoraRTCRemoteUser[]>>,
  event: 'user-joined' | 'user-left'
) => {
  return (user: IAgoraRTCRemoteUser) => {
    if (event === 'user-joined') setUsers((users) => [...users, user]);
    if (event === 'user-left') setUsers((users) => users.filter((el) => el.uid !== user.uid));
  };
};

export const getConsultation = async (consultationID: string) => {
  const { data } = await HttpHandler({
    url: `${environment.CONSULTATION_URL}/${consultationID}`,
    method: 'GET',
  });

  return data as ConsultationType;
};

export const switchDeviceIfMissing =
  (deviceList: MediaDeviceInfo[], cameraTrack: ICameraVideoTrack | null, audioTrack: IMicrophoneAudioTrack | null) =>
  () => {
    /**
     * 1. Current audio/video device missing?
     * 2. If yes what kind of device are missing(audio, video)
     * 3. If audio/video missing, check is device list have at least one available device, if yes switch to this device another way disable audio input
     */
    let audioMediaStreamTrack = audioTrack?.getMediaStreamTrack();
    const currentAudioDeviceID = audioMediaStreamTrack?.getSettings().deviceId;

    let videoMediaStreamTrack = cameraTrack?.getMediaStreamTrack();
    const currentVideoDeviceID = videoMediaStreamTrack?.getSettings().deviceId;

    if (!currentVideoDeviceID && !currentAudioDeviceID) return;

    const isAudioDeviceMissing = !deviceList.find(({ deviceId }) => deviceId === currentAudioDeviceID);
    const isVideoDeviceMissing = !deviceList.find(({ deviceId }) => deviceId === currentVideoDeviceID);

    const firstAvailableDevicesByAudioInputs = deviceList.find(({ kind }) => kind === 'audioinput');
    const firstAvailableDevicesByVideoInputs = deviceList.find(({ kind }) => kind === 'videoinput');

    if (isAudioDeviceMissing && !firstAvailableDevicesByAudioInputs) audioTrack?.setMuted(true);

    if (isVideoDeviceMissing && !firstAvailableDevicesByVideoInputs) cameraTrack?.setEnabled(false);

    if (isVideoDeviceMissing && firstAvailableDevicesByVideoInputs)
      cameraTrack?.setDevice(firstAvailableDevicesByVideoInputs.deviceId);

    if (isAudioDeviceMissing && firstAvailableDevicesByAudioInputs)
      audioTrack?.setDevice(firstAvailableDevicesByAudioInputs.deviceId);
  };

export const getBrowserVersion = () => {
  let temp;
  const { userAgent } = navigator;

  let match = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ?? [];
  if (/trident/i.test(match[1])) {
    temp = /\brv[ :]+(\d+)/g.exec(userAgent) ?? [];
    return 'IE ' + (temp[1] || '');
  }
  if (match[1] === 'Chrome') {
    temp = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
    if (temp != null) return temp.slice(1).join(' ').replace('OPR', 'Opera');
  }
  match = match[2] ? [match[1], match[2]] : [];
  if ((temp = userAgent.match(/version\/(\d+)/i)) != null) match.splice(1, 1, temp[1]);
  return match.join(' ');
};
